import { FolderTree, Layers } from "lucide-react";
import type React from "react";
import type { GraphViewMode } from "@/features/graph/types/graph-ui";

interface GraphViewModeTabsProps {
	viewMode: GraphViewMode;
	onChange: (viewMode: GraphViewMode) => void;
}

const GraphViewModeTabs: React.FC<GraphViewModeTabsProps> = ({ viewMode, onChange }) => {
	return (
		<div className="flex rounded-lg border border-subtle p-0.5 surface">
			<button
				type="button"
				onClick={() => onChange("workspace")}
				className={`rounded-md p-2 transition-colors ${
					viewMode === "workspace" ? "bg-primary-100 text-primary-600" : "text-muted soft-hover"
				}`}
				aria-label="Workspace view"
			>
				<Layers className="h-4 w-4" />
			</button>
			<button
				type="button"
				onClick={() => onChange("hierarchy")}
				className={`rounded-md p-2 transition-colors ${
					viewMode === "hierarchy" ? "bg-primary-100 text-primary-600" : "text-muted soft-hover"
				}`}
				aria-label="Hierarchy view"
			>
				<FolderTree className="h-4 w-4" />
			</button>
		</div>
	);
};

export default GraphViewModeTabs;
